import React from 'react'
import clsx from 'clsx'
import Link from 'next/link'

import Field from '~/truck/field'
import NewButton from '~/truck/new-button/NewButton'

interface ResetPasswordFormProps {
  handleSubmit: () => void
  submitting: boolean
  submitSucceeded: boolean
  className?: string
}

function ResetPasswordForm({ handleSubmit, submitting, submitSucceeded, className }: ResetPasswordFormProps) {
  if (submitSucceeded) {
    return (
      <div className={clsx('flex flex-col gap-4', className)}>
        <p>
          Te hemos enviado un correo con instrucciones para cambiar tu contraseña. Si este no aparece dentro de unos
          minutos, revisa tu spam.
        </p>
        <Link href="/ingresar">
          <NewButton>Regresar a iniciar sesión</NewButton>
        </Link>
      </div>
    )
  }

  return (
    <form className={clsx('flex flex-col gap-4')} onSubmit={handleSubmit}>
      <Field name="email" placeholder="Correo electrónico" />
      <NewButton loading={submitting} type="submit">
        Recuperar Contraseña
      </NewButton>
    </form>
  )
}

export default ResetPasswordForm
